<template>
    <div>
        <!-- 上传文件按钮 -->
        <el-button type="primary" @click="showUploadDialog = true">上传新文件</el-button>

        <!-- PDF 播放器 -->
        <div class="pdf-viewer">
            <iframe :src="pdfUrl" frameborder="0" class="pdf-iframe"></iframe>
        </div>

        <!-- 上传文件对话框 -->
        <el-dialog title="上传文件" v-model="showUploadDialog" width="500px" @close="handleClose">
            <el-upload ref="upload" v-model:file-list="fileList" :auto-upload="false" :http-request="handleFileUpload"
                :on-change="onFileChange" :multiple="false" :limit=2>
                <el-button>选择文件</el-button>
            </el-upload>
            <div v-if="uploadProgress > 0">
                <p>上传进度：{{ uploadProgress }}%</p>
                <el-progress :percentage="uploadProgress"></el-progress>
            </div>
            <div class="dialog-actions">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="uploadFile" :disabled="!file">上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { defineComponent, } from "vue";

export default defineComponent({
    data() {
        return {
            courseId: null, // 当前课程 ID
            pdfUrl: "", // PDF 文件 URL
            showUploadDialog: false, // 上传对话框显示状态
            fileList: [], // 选中文件列表
            file: null, // 当前选中的文件
            uploadProgress: 0, // 上传进度
        };
    },
    async mounted() {
        this.courseId = this.$route.params.courseId;
        this.fetchBriefFileUrl();
    },
    methods: {
        // 获取 PDF 文件 URL
        async fetchBriefFileUrl() {
            try {
                const response = await this.$axios.post("/api/course/brief-file", {
                    courseId: this.courseId,
                });
                this.pdfUrl = this.$baseFileUrl + response.data.fileUrl;
            } catch (error) {
                console.error("Error fetching PDF file URL:", error);
            }
        },

        // 关闭上传对话框
        handleClose() {
            this.showUploadDialog = false;
            this.file = null;
            this.fileList = [];
            this.uploadProgress = 0;
        },

        // 选择文件时的处理
        onFileChange(newFile, fileList) {
            console.log('onFileChange triggered', newFile, fileList);

            // 获取当前文件列表的引用
            this.fileList = fileList;  // 直接通过文件列表参数同步

            // 如果文件列表有超过一个文件，删除第一个
            if (this.fileList.length > 1) {
                this.fileList.splice(0, 1);  // 删除第一个文件
            }

            // 更新当前文件
            this.file = newFile.raw;  // 更新当前文件
        },

        // 上传文件
        async handleFileUpload({ file: rawFile }) {
            const chunkSize = 5 * 1024 * 1024; // 每块大小 5MB
            const totalChunks = Math.ceil(rawFile.size / chunkSize);
            const fileName = rawFile.name;
            const maxRetries = 3; // 最大重试次数

            for (let i = 0; i < totalChunks; i++) {
                const start = i * chunkSize;
                const end = Math.min(rawFile.size, start + chunkSize);
                const fileChunk = rawFile.slice(start, end);

                const formData = new FormData();
                formData.append("fileName", fileName);
                formData.append("id", this.courseId);
                formData.append("fileChunk", fileChunk);
                formData.append("index", i);

                let retries = 0;
                while (retries < maxRetries) {
                    try {
                        // 尝试上传文件块
                        await this.$axios.post("/api/resource/upload", formData);
                        this.uploadProgress = Math.round(((i + 1) / totalChunks) * 100);
                        break; // 成功后跳出重试循环
                    } catch (error) {
                        retries++;
                        console.error(`文件块 ${i} 上传失败，重试次数：${retries}`, error);
                        if (retries >= maxRetries) {
                            // 超过最大重试次数后，抛出错误并终止上传
                            this.uploadProgress = 0;
                            throw new Error(`文件块 ${i} 上传失败，已达到最大重试次数`);
                        }
                    }
                }
            }

            try {
                // 合并文件
                await this.$axios.post("/api/resource/upload/merge", {
                    fileName,
                    id: this.courseId,
                    type: 1,
                });

                // 上传完成后刷新 PDF
                this.fetchBriefFileUrl();
                this.handleClose();
            } catch (error) {
                console.error("文件合并失败", error);
                throw new Error("文件合并失败，请重试");
            }
        },


        // 提交上传
        uploadFile() {
            if (this.file) {
                this.$refs.upload.submit();
            }
        },
    },
});
</script>

<style scoped>
/* PDF 播放器样式 */
.pdf-viewer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pdf-iframe {
    width: 80%;
    height: 80vh;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 对话框按钮操作区域 */
.dialog-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
</style>
